<div
  class="app-shell"
  [class.app-shell-header-only]="!showSidebar"
>
  @if (showSidebar) {
  <aside
    class="app-sidebar d-none d-md-flex flex-column"
    [class.app-sidebar-collapsed]="collapsed"
  >
    <div class="app-sidebar-brand">
      @if (logoUrl && !collapsed) {
      <img
        [src]="logoUrl"
        alt="logo"
        class="app-sidebar-logo"
      />
      @if (logoBadge) {
      <span class="app-logo-badge">{{ logoBadge }}</span>
      }
      }
      <button
        type="button"
        pButton
        [text]="true"
        [rounded]="true"
        severity="secondary"
        class="app-sidebar-collapse-btn"
        (click)="collapsed = !collapsed"
      ><i class="{{ collapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line' }}"></i></button>
    </div>

    <nav class="app-nav">
      <ng-container *ngTemplateOutlet="navTemplate; context: { showLabel: !collapsed }"></ng-container>
    </nav>

  </aside>
  }

  <div class="app-main">
    <header
      class="app-topbar"
      [class.app-topbar-scrolled]="scrolled"
    >
      <div
        class="app-topbar-start"
        [class.app-topbar-start-scrolled]="scrolled"
      >
        @if (!showSidebar && logoUrl) {
        <a
          routerLink="/home"
          class="app-topbar-brand"
          aria-label="reflact Portal – Startseite"
          i18n-aria-label="@@portalHomeLink"
        >
          <img
            [src]="logoUrl"
            alt="reflact Portal"
            class="app-sidebar-logo app-topbar-logo"
          />
          @if (logoBadge) {
          <span class="app-logo-badge">{{ logoBadge }}</span>
          }
        </a>
        }
        <ng-content select="[topbar-start]"></ng-content>
      </div>
      @if (showSidebar) {
      <button
        type="button"
        pButton
        [text]="true"
        [rounded]="true"
        severity="secondary"
        class="d-md-none"
        (click)="mobileNavVisible = true"
      ><i class="ri-menu-line"></i></button>
      }

      <div class="app-topbar-spacer"></div>

      <div
        class="app-topbar-actions"
        [class.app-topbar-actions-scrolled]="scrolled"
      > <ng-content select="[topbar-extra]"></ng-content>
      </div>
    </header>

    <main class="app-content">
      <ng-content></ng-content>
    </main>
  </div>
</div>

@if (showSidebar) {
<p-drawer
  [(visible)]="mobileNavVisible"
  position="left"
  [modal]="true"
  styleClass="app-mobile-drawer"
>
  <div class="app-sidebar-brand">
    @if (logoUrl) {
    <img
      [src]="logoUrl"
      alt="logo"
      class="app-sidebar-logo"
    />
    }
  </div>
  <nav
    class="app-nav"
    (click)="mobileNavVisible = false"
  >
    <ng-container *ngTemplateOutlet="navTemplate; context: { showLabel: true }"></ng-container>
  </nav>
  @if (logoutFunction) {
  <div class="app-sidebar-footer">
    <button
      type="button"
      pButton
      [outlined]="true"
      class="w-100"
      (click)="logoutFunction()"
    ><i class="ri-logout-box-r-line me-2"></i><span i18n="@@bodyLayoutLogout">Abmelden</span></button>
  </div>
  }
</p-drawer>
}

<ng-template
  #navTemplate
  let-showLabel="showLabel"
>
  <ng-container *ngFor="let item of navItems">
    <ng-container *ngIf="item.children as children; else singleLink">
      @if (showLabel) {
      <div class="app-nav-title">{{ item.name }}</div>
      }
      <a
        *ngFor="let child of children"
        [routerLink]="child.url"
        routerLinkActive="active"
        class="app-nav-link app-nav-link-child"
      >
        <i class="app-nav-icon {{ child.icon }}"></i>
        @if (showLabel) {
        <span class="app-nav-label">{{ child.name }}</span>
        }
      </a>
    </ng-container>
    <ng-template #singleLink>
      @if (!item.title) {
      <a
        [routerLink]="item.url"
        routerLinkActive="active"
        class="app-nav-link"
      >
        <i class="app-nav-icon {{ item.icon }}"></i>
        @if (showLabel) {
        <span class="app-nav-label">{{ item.name }}</span>
        }
      </a>
      }
    </ng-template>
  </ng-container>
</ng-template>
